import { createInstance } from './axios.api'
import { timeout } from '@/utils/timeout.utils'
import {
  AuthenticationResponse,
  CollectStatusResponse,
  User
} from '@/types/contact-form-page.types'

const STATUS_FAILED = 'Failed'
const STATUS_PENDING = 'Pending'

const submitAuthentication = async (personalIdentityNumber: string): Promise<AuthenticationResponse> => {
  const axios = createInstance(process.env.VUE_APP_CIAM_URL)

  const { data } = await axios.post('/authentication', {
    userId: personalIdentityNumber
  })
  return data
}

const collectStatus = async (token: string): Promise<CollectStatusResponse> => {
  const axios = createInstance(process.env.VUE_APP_CIAM_URL)

  return new Promise((resolve, reject) => {
    const collectToken = async (): Promise<void> => {
      await timeout(5000)
      try {
        const { data } = await axios.post('/collect', { token })

        if (data.status === STATUS_PENDING) {
          collectToken()
          return
        }

        resolve(data)
      } catch {
        reject()
      }
    }

    collectToken()
  })
}

const requestAuthenticationCancellation = async (token: string): Promise<AuthenticationResponse> => {
  const axios = createInstance(process.env.VUE_APP_CIAM_URL)

  const { data } = await axios.post('/cancel', { token })
  return data
}

const getUserData = async (token: string): Promise<User> => {
  const axios = createInstance(process.env.VUE_APP_CIAM_URL)

  const { data } = await axios.post('/user', { token })
  return data
}

export {
  submitAuthentication,
  collectStatus,
  requestAuthenticationCancellation,
  getUserData,
  STATUS_FAILED
}
